var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 20,
    viewBox: "0 0 55 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 3.31792e-06C12.3122 1.99016e-06 -2.68111e-06 7.03331 -3.8147e-06 20L55 20C55 7.03332 42.6878 4.64568e-06 27.5 3.31792e-06Z",
    fill: "#DE9079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 9C15.0736 9 5 12.8683 5 20L50 20C50 12.8683 39.9264 9 27.5 9Z",
    fill: "#D67A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.39827C12.9123 1.84884 19.8155 0 27.4608 0C35.3539 0 42.4559 1.97061 47.3928 5.7487C42.6269 7.2285 35.9248 8 28.789 8C20.8553 8 13.1845 7.10651 8 5.39827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthK);
export default __webpack_public_path__ + "static/media/Mouth K.308e90b1ede46dbc52a17ca20384b6ef.svg";
export { ForwardRef as ReactComponent };